import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import { useMediaQuery } from '@material-ui/core'

export default function StickyBanner({
  actionText = "詳細を見る",
  actionUrl = "#",
  backgroundColor,
  textColor,
  desktopPadding = '12px 32px',
  mobilePadding = '10px 26px',
  desktopFontSize = '16px',
  mobileFontSize = '14px',
  desktopRight = '30px',
  mobileRight = '12px',
  desktopBottom = '30px',
  mobileBottom = '20px'
}) {
  const { palette } = useTheme()
  const isDesktop = useMediaQuery('(min-width:960px)')
  
  const handleAction = () => {
    if (actionUrl && actionUrl !== "#") {
      window.open(actionUrl, '_blank')
    }
  }

  return (
    <button
      onClick={handleAction}
      style={{
        position: 'fixed',
        bottom: isDesktop ? desktopBottom : mobileBottom,
        right: isDesktop ? desktopRight : mobileRight,
        backgroundColor: backgroundColor || palette.primary.main,
        color: textColor || palette.primary.contrastText,
        border: 'none',
        borderRadius: '25px',
        padding: isDesktop ? desktopPadding : mobilePadding,
        fontSize: isDesktop ? desktopFontSize : mobileFontSize,
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        zIndex: 9999,
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)',
        transition: 'all 0.3s ease',
        minWidth: 'fit-content',
        whiteSpace: 'nowrap'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'scale(1.05)'
        e.target.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)'
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'scale(1)'
        e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'
      }}
    >
      {actionText}
    </button>
  )
}